import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Activity, MessageSquare, RefreshCw, Sparkles } from 'lucide-react';
const kitItems = [{
  label: 'Crisis',
  title: 'Anatomía de la Crisis',
  desc: 'Entendé por qué el cerebro de tu hijo entra en crisis y por qué en ese momento no puede cooperar aunque quiera.',
  icon: Activity,
  tint: 'bg-coral-50/70 border-coral-100',
  chip: 'bg-coral-100 text-coral-600',
  labelColor: 'text-coral-600'
}, {
  label: 'Emergencia',
  title: '4 Protocolos de Intervención',
  desc: 'Protocolo 11PM · Contención Segura · Salida de Emergencia · Post-Escuela. Pasos exactos para cada situación.',
  icon: ShieldAlert,
  tint: 'bg-amber-50/70 border-amber-100',
  chip: 'bg-amber-100 text-amber-600',
  labelColor: 'text-amber-600'
}, {
  label: 'Comunicación',
  title: 'Fichas de Emergencia Avanzadas',
  desc: '10 fichas de comunicación para usar durante y después de la crisis. Las que no están en el Tomo 1.',
  icon: MessageSquare,
  tint: 'bg-teal-50/60 border-teal-100',
  chip: 'bg-teal-100 text-teal-600',
  labelColor: 'text-teal-600'
}, {
  label: 'Recuperación',
  title: 'Plan de Reset de 30 Días',
  desc: 'Cómo recuperar la paz en el hogar después de una crisis intensa y evitar que se repita al día siguiente.',
  icon: RefreshCw,
  tint: 'bg-stone-50/60 border-stone-200',
  chip: 'bg-stone-200 text-stone-600',
  labelColor: 'text-stone-600'
}];
export function AcceleratorKit() {
  return <section className="py-12 md:py-16 bg-cream text-teal-900" data-id="element-1">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-2">
        <div className="text-center mb-10" data-id="element-3">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 mb-4 rounded-full bg-amber-100 border border-amber-200 text-amber-700 font-bold tracking-wider uppercase text-xs" data-id="element-4">
            <Sparkles className="w-3.5 h-3.5" data-id="element-5" />
            Solo en versión Premium
          </span>
          <h2 className="text-3xl font-bold mb-4" data-id="element-6">EL PROTOCOLO DE PAZ</h2>
          <p className="text-stone-600 max-w-xl mx-auto" data-id="element-7">
            El Manual Maestro de Crisis y Conductas Desafiantes.{' '}
            <span className="font-semibold text-teal-900" data-id="element-8">
              Todo lo que necesitás para los momentos donde nada parece
              funcionar, listo para imprimir y usar desde el primer día.
            </span>
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4" data-id="element-9">
          {kitItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className={`border shadow-sm rounded-2xl p-6 ${item.tint}`} data-id="element-10">
              <div className="flex items-center gap-3 mb-3" data-id="element-11">
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${item.chip}`} data-id="element-12">
                  <item.icon className="w-5 h-5" data-id="element-13" />
                </div>
                <span className={`text-xs font-bold uppercase tracking-wider ${item.labelColor}`} data-id="element-14">
                  {item.label}
                </span>
              </div>
              <h3 className="font-bold text-lg mb-2 text-teal-900" data-id="element-15">
                {item.title}
              </h3>
              <p className="text-sm text-stone-500" data-id="element-16">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}